module.exports = require('./helpers/bundle-url').getBundleURL('aOd2H') + "logo.c51670a8.svg";